<script lang="ts">
	import { algoliaFireJobOfferLikedEvent } from "@stores/algolia";
	import { isFavourite, toggleFavourite } from "@stores/favourites";
	import { user } from "@stores/user";
	import FavoriteIcon from "@svg/FavoriteIcon.svelte";
	import { navigate } from "astro:transitions/client";
	import Button, { type Props as ButtonProps } from "./Button.svelte";

	export let objectID: string = "";
	export let index: number = -1;
	export let buttonProps: ButtonProps = {};

	const isLikedByCurrentUser = isFavourite(objectID);
	let loading = false;

	async function _toggleFavourite() {
		// If there is no user, navigate them to /signin.
		if (!$user) {
			navigate("/signin");
			return;
		}
		// Prevent spam clicks
		if (loading) {
			return;
		}
		loading = true;
		if (!$isLikedByCurrentUser) {
			algoliaFireJobOfferLikedEvent({
				objectID,
				afterSearch: {
					positions: index
				}
			});
		}
		await toggleFavourite(objectID);
		loading = false;
	}

	$: color = $isLikedByCurrentUser ? "rose" : "black";
</script>

<Button
	css="px-2"
	variant={"btn-text"}
	{color}
	onclick={(event) => {
		//stop event bubble
		event.stopPropagation();
		event.preventDefault();
		_toggleFavourite();
	}}
	{...buttonProps}
>
	{#if !$isLikedByCurrentUser}
		<FavoriteIcon class="h-6 w-6 fill-current " />
	{:else}
		<FavoriteIcon filled class="h-6 w-6 fill-current " />
	{/if}
</Button>
